import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Script from "react-load-script";

import { API_URL, FORTE_API, FORTE_SCRIPT, isCardType } from "../helpers";

import "../Donate/styles.css";

import CreditPayment from "../Donate/CreditPayment";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Payment = () => {
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const query = new URLSearchParams(useLocation().search);

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/paymentInit`);
		const params = {
			code: query.get("code") || "",
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("cardholder", json.data.cardholder);
				setDetails({
					...json.data,
				});
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/payment`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "number" || key === "expdate" || key === "code") {
			} else {
				data.append(key, value);
			}
		});
		data.append("donationId", details.donationId);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("donation", json.donation);
				handlePayment();
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handlePayment = () => {
		if (!names.number || !names.expdate || !names.code) {
			let array = [];
			if (!names.number) {
				array.push("number");
			}
			if (!names.expdate) {
				array.push("expdate");
			}
			if (!names.code) {
				array.push("code");
			}
			setErrors(array);
			setMsg({
				type: "error",
				text: "Please make an entry in all payment fields (*).",
			});
			return false;
		} else if (!isCardType(names.number || "")) {
			setMsg({
				type: "error",
				text: "Please enter a valid credit card number.",
			});
			return false;
		} else if (
			names.expdate.split("/").length !== 2 ||
			names.expdate.length < 6
		) {
			setMsg({
				type: "error",
				text: "Please check the format of your expiration date (mm/yyyy).",
			});
			return false;
		} else {
			const number = names.number.trim().replace(/\s/g, "").replace(/-/g, "");
			const array = names.expdate.trim().split("/");
			const month = array[0] || "";
			const year = array[1] || "";

			const data = {
				api_login_id: FORTE_API,
				card_number: number,
				expire_month: month,
				expire_year: year,
				cvv: names.code.trim() || "",
			};
			window.forte
				.createToken(data)
				.success(onTokenCreated)
				.error(onTokenFailed);
		}
	};

	const handleScriptCreate = () => {
		handleUpdate("scriptLoaded", false);
	};

	const handleScriptError = () => {
		setMsg({
			type: "error",
			text: "An error occurred loading the payment gateway.",
		});
	};

	const handleScriptLoad = () => {
		handleUpdate("scriptLoaded", true);
	};

	const onTokenCreated = async (response) => {
		const url = new URL(`${API_URL}/paymentSubmit`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "number" || key === "expdate" || key === "code") {
			} else {
				data.append(key, value);
			}
		});
		data.append("donationId", details.donationId);
		data.append("ott", response.onetime_token);
		data.append("cardType", response.card_type);
		data.append("lastFour", response.last_4);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: "/receipt",
					state: {
						id: json.id,
						type: "payment",
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const onTokenFailed = (response) => {
		setMsg({
			type: "error",
			text: `Error. ${response.response_description}`,
		});
	};

	return (
		<div id="full-column">
			<Hdg section="Donations" />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="alert well-sm alert-warning" role="alert">
						<i className="fa fa-exclamation-triangle " /> &nbsp;Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity Donation
						Pledge Payment Form
					</div>

					<p>
						Thank you for submitting your donation on {details.date}, please
						honor your pledge commitment by paying with your credit or debit
						card below. On behalf of Champions{" "}
						<span style={{ fontStyle: "italic" }}>fore</span> Charity and
						everyone associated with the Valero Texas Open, thank you for your
						support and contribution to help charities and schools within our
						community.
					</p>

					<div id="left-column" style={{ width: "100%", padding: "0" }}>
						<table className="approved" style={{ marginBottom: "25px" }}>
							<thead>
								<tr>
									<th>No.</th>
									<th className="left">Donation Description</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{details.donationId}</td>
									<td className="left">{details.items[0].descr}</td>
									<td className="right">{details.items[0].total}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<th
										colSpan="2"
										className="right"
										style={{ paddingRight: "10px" }}
									>
										TOTAL
									</th>
									<th className="right">{details.total}</th>
								</tr>
								<tr className={details.payment.descr === "" ? "hidden" : ""}>
									<td
										colSpan="2"
										className="right"
										style={{ paddingRight: "10px" }}
									>
										{`${details.payment.descr}`}
									</td>
									<td className="right ">{`${details.payment.amt}`}</td>
								</tr>
							</tfoot>
						</table>

						<Script
							url={FORTE_SCRIPT}
							onCreate={handleScriptCreate}
							onError={handleScriptError}
							onLoad={handleScriptLoad}
						/>

						<form method="post" action="/" onSubmit={(e) => handleSubmit(e)}>
							<CreditPayment
								update={handleUpdate}
								data={{
									cardholder: names.cardholder,
									number: names.number || "",
									expdate: names.expdate || "",
									code: names.code || "",
									amt: names.amt || 0,
									charity: details.charity,
								}}
								errors={errors}
							/>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Submit Payment" />
								</div>
							</div>
						</form>
					</div>
					<div
						id="right-column"
						style={{
							width: "0",
							paddingTop: "15px",
							paddingRight: "0",
							paddingLeft: "0",
						}}
					/>
				</>
			)}
		</div>
	);
};

export default Payment;
